import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const LabelIconPairEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    label: z.string().optional().nullable(),
    icon: z.string().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
